import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
// Compiled Tailwind for the SDK's capture UI. Imported first so verify-app's
// own screen styles below win any overlapping rules.
import "@inertiax/kyc-react/styles";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
